import React from 'react';
// import InfiniteScroll from 'react-infinite-scroller';
import '../../../../styles/searchpage.css';
import '../../../../styles/landingPage.css';
import '../../../../styles/artworks.css';
import '../../../../styles/common_elements.css';
import { Redirect, withRouter } from 'react-router-dom';
import ArtworkCard from '../../../cardHolders/artworksCard';
import ArtistCard from '../../../cardHolders/artistsCard';
import { inject, observer } from 'mobx-react';
import {
    validateIfInputHasCharacters,
    validateIfInputHasSpaces,
    validateIfInputHasUpperCaseLetter,
    validateIfInputHasYourMasterpieces,
    validateInputLength
} from "../../../../helpers/validationChecks";
// import InfiniteScroll from 'react-infinite-scroll-component';
import OB1 from '../../../Home/onboarding/onboarding1-modal'
import OB2 from '../../../Home/onboarding/onboarding2-modal'
import OB3 from '../../../Home/onboarding/onboarding3-modal'
import ReactGA from "react-ga";

var qs = require('qs')

@observer
@observer
@inject('searchPageArtworksStore', 'commonStore', 'authStore', 'userStore', 'navigatorStore')
class searchResultspage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            artworksList: false,
            artistList: false,
            search: false,
            userWantsToSeeType: false
        }
    }
    componentDidMount() {
        //console.log('[componentWillReceiveProps] srchpage ', !this.props.match.params.search)
        ReactGA.pageview('/Search screen');
        var str = this.props.match.params.search;
        str = str.replace(/[^a-zA-Z ]/g, "");
        this.searchOnline(str);
        if (localStorage.hasOwnProperty("userData")) {


            this.props.userStore.pulluser().then((result) => {
                // console.log("{this is pulled user}", result)
                if (!result.data[0].display_name && !!result.data[0].old_display_name) {
                    if ((result.data[0].old_display_name) && !validateInputLength(result.data[0].old_display_name, 6, 30)) {
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        // this.props.navigatorStore.openErrorModal("username should contain 6-30 characters");
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && !validateIfInputHasSpaces(result.data[0].old_display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain spaces")
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && validateIfInputHasCharacters(result.data[0].old_display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain characters");
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && validateIfInputHasUpperCaseLetter(result.data[0].old_display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain an uppercase letter")
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && validateIfInputHasYourMasterpieces(result.data[0].old_display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain yourmasterpieces in it")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    var formData = new FormData();
                    formData.append("display_name", this.state.formInputs.display_name)
                    // if (!!this.state.formInputs.display_name && (this.state.curr_display_name != this.state.formInputs.display_name))
                    this.props.userStore.validateDisplayName(formData)
                        .then((response) => {
                            // console.log(response)
                            if (response.error == "True") {
                                // console.log("tell i am coming here at leats")
                                this.props.navigatorStore.openOB3Modal();
                                this.setState({
                                    onboardingThreeIncomplete: true,
                                    // formInputs: { ...this.state.formInputs, display_name: "" }
                                })
                                // this.props.navigatorStore.openErrorModal(response.data)
                                return;
                            }
                            else {
                                // console.log("tell i am coming here at leats")
                                this.props.navigatorStore.openOB3Modal();
                                this.setState({
                                    onboardingThreeIncomplete: true
                                })
                            }
                        })
                        .catch((err => {
                            // console.log("tell i am coming here at leats")
                            this.props.navigatorStore.openOB3Modal();
                            this.setState({
                                onboardingThreeIncomplete: true,



                            })
                        }));
                }

                if (result.data[0].display_name) {
                    if ((result.data[0].display_name) && !validateInputLength(result.data[0].display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username should contain 6-30 characters");
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && !validateIfInputHasSpaces(result.data[0].display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain spaces")
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && validateIfInputHasCharacters(result.data[0].display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain characters");
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && validateIfInputHasUpperCaseLetter(result.data[0].display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain an uppercase letter")
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && validateIfInputHasYourMasterpieces(result.data[0].display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain yourmasterpieces in it")
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                }

                if (!result.data[0].full_name ||
                    !result.data[0].country ||
                    //  !response.data.user_profile[0].full_name || 
                    //  !response.data.user_profile[0].user.email || 
                    //  !response.data.user_profile[0].display_name || 
                    !result.data[0].display_name ||
                    result.data[0].display_name.length >= 30 ||
                    !result.data[0].primary_email ||
                    !result.data[0].preferred_currency

                ) {
                    // console.log("profile null")
                    // console.log("tell i am coming here at leats")
                    this.props.navigatorStore.openOB3Modal();
                    this.setState({
                        onboardingThreeIncomplete: true
                    })
                    // this.state.makeOnboardingThreeIncomplete()
                }

            })
        } else {
            this.setState({ shareUrl: true },


            )
        }
    }

    searchOnline(str) {
        this.props.searchPageArtworksStore.getInitialResultsArtworks({ search: str })
            .then((res) => {
                // console.log("[look at response]", res)
                this.setState({
                    response: res.data,
                    artworksList: res.data.data
                }, function () {
                    // console.log("[look at artworks state]", this.state.artworksList);
                    // console.log(this.state.response)
                })
            })
        this.props.searchPageArtworksStore.getInitialResultsArtists({ search: str })
            .then((res) => {
                // console.log("[look at response]", res)
                this.setState({
                    response: res.data,
                    artistList: res.data.data
                }, function () {
                    // console.log("[look at artworks state]", this.state.artworksList);
                    // console.log(this.state.response)
                })
            })
    }

    componentWillReceiveProps(nextProps) {
        // console.log('[componentWillReceiveProps] srchpage ', nextProps.match.params.search, !this.props.match.params.search)
        var str = nextProps.match.params.search;
        let searchableString = str;
        // console.log({ matcher: searchableString != this.state.search, inState: this.state.search, iHave: searchableString })
        if (!this.props.match.params.search || searchableString != this.state.search) {
            this.setState({
                search: searchableString
            }, () => {
                this.searchOnline(searchableString);
            })
            // document.addEventListener('scroll', this.trackScrolling);
        } else setTimeout(() => {

            // console.log('[mounted] componentWillReceiveProps srchpage nextProps hihihuhu ', this.state.shareUrl)
            // debugger;
            // if (this.state.shareUrl || str != this.state.artistId) {

            if (this.state.shareUrl && (!!this.props.authStore.loginDone || this.props.authStore.RegisterSuccess)) {
                // console.log('[mounted] srchpage next hihihuhu', nextProps.match.params.id)

                this.setState({
                    shareUrl: false,

                }, () => {
                    // console.log('[mounted] srchpage next hihihuhu', nextProps.match.params.id, this.props.authStore.RegisterSuccess, localStorage.getItem("just_registered"))
                    if (localStorage.hasOwnProperty("userData")) {
                        // window.location.reload()
                        this.searchOnline(searchableString);
                        if (this.props.authStore.onboardingThreeIncomplete || this.props.authStore.onboardingTwoIncomplete) {
                            // console.log("hihi tell i am coming here at leats")
                            this.props.navigatorStore.openOB3Modal();

                        }
                        else if (this.props.authStore.RegisterSuccess || localStorage.getItem("just_registered")) {
                            localStorage.removeItem("just_registered");
                            this.props.navigatorStore.openOB1Modal();

                        }
                    }
                })
            }
        }, 1000)
    }

    handleViewAll(type) {
        this.setState({
            userWantsToSeeType: type
        })
    }

    render() {
        if (this.state.userWantsToSeeType) {
            return (
                <Redirect push to={{ pathname: `/searchpage_${this.state.userWantsToSeeType}/${this.state.search}` }}></Redirect>
            )
        }

        return (
            <div className="searchpage-container bg-white" id="scrollableDiv">
                <div className="bg-grey pb-25 mb-25">
                    <div className="searchpage-content-container">
                        <div className="searchpage-heading">
                            <div className="heading-btn-row filter-heading pt-15">
                                <div className="col-md-12 pl-0">
                                    <h3 className="search-heading" style={{ fontWeight: 700 }}>
                                        Search Result for {`"${((this.state.search) ? this.state.search : "")}"`}
                                    </h3>
                                     {/* <hr className="line-category-name "></hr> */}
                                </div>
                                {/* <Filter handelFilterChangeMaster={this.handelFilterChangeMaster.bind(this)} currentOverallFilterState={this.state.filterState} /> */}
                            </div>
                        </div>
                    </div>
                </div>

                <OB1 />
                <OB2 />
                <OB3 />

                <div className="bg-white pb-25 mb-25">

                    <div className="searchpage-content-container bg-white">
                        <div className="heading-btn-row filter-heading pt-15">
                            <div className="col-md-6 pl-0">
                                <h3 className="heading-left-text">PEOPLE</h3>
                                <hr className="line-category-name"></hr>
                            </div>
                            <div className="col-md-6 text-right" style={{ display: (!this.state.artistList.length) ? "none" : "" }}>
                                <button onClick={() => this.handleViewAll("artists")} className="view-all-btn">
                                    <span>View All</span>
                                </button>
                            </div>
                            {/* <Filter handelFilterChangeMaster={this.handelFilterChangeMaster.bind(this)} currentOverallFilterState={this.state.filterState} /> */}
                        </div>
                        <div className="bg-white" style={{
                            flexWrap: "wrap", paddingTop: "3%"
                        }}>



                            <div style={{ display: (!this.state.artistList.length) ? "" : "none" }}>

                                <div className="gray-category-description">No results to show</div>
                            </div>
                            <ArtistCard artistData={this.state.artistList} />

                        </div>
                    </div>
                </div>

                <div className="bg-white pb-25">
                    {/* <div className="bg-grey pb-25"> */}

                    <div className="searchpage-content-container bg-white">
                        <div className="heading-btn-row filter-heading ">
                            <div className="col-md-6 pl-0">
                                <h3 className="heading-left-text">ARTWORKS</h3>
                                <hr className="line-category-name"></hr>
                            </div>
                            <div className="col-md-6 text-right" style={{ display: (!this.state.artworksList.length) ? "none" : "" }}>
                                <button onClick={() => this.handleViewAll("artworks")} className="view-all-btn">
                                    <span>View All</span>
                                </button>
                            </div>
                            {/* <Filter handelFilterChangeMaster={this.handelFilterChangeMaster.bind(this)} currentOverallFilterState={this.state.filterState} /> */}
                        </div>
                        <h3 className="heading-left-text"></h3>
                        <div className="bg-white" style={{
                            // backgroundColor: "#f6f6f6",
                            flexWrap: "wrap", paddingTop: "3%"
                        }}>



                            <div style={{ height: "360px", display: (!this.state.artworksList.length) ? "" : "none" }}>

                                <div className="gray-category-description">No results to show</div>
                            </div>
                            <ArtworkCard artworkData={this.state.artworksList} />
                            {/* </InfiniteScroll> */}
                        </div>
                    </div>
                </div>


            </div>
        )
    }

}

export default withRouter(observer(searchResultspage))


// WEBPACK FOOTER //
// ./src/components/Home/profile/search/searchPage.js